// extracted by mini-css-extract-plugin
export default {"pill":"CustomSelectInput_pill__jR7JO","border":"CustomSelectInput_border__fngkB"};